import facts from './harbor-facts.json';

export const HARBOR_FACTS = facts;

export const HARBOR_COMPARE_SLUGS = facts.compareSlugs;

export function harborMonthlyPriceLabel(): string {
  return facts.monthlyPriceLabel;
}

export function harborAnnualPriceLabel(): string {
  return facts.annualPriceLabel;
}

export function buildHarborSoftwareApplicationJsonLd(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Harbor',
    applicationCategory: facts.applicationCategory,
    operatingSystem: facts.operatingSystem,
    description:
      'Co-parenting app with expense tracking, secure messaging, custody scheduling, Temperature Check, and court-ready exports.',
    url: facts.siteUrl,
    featureList: facts.featureList,
    offers: [
      {
        '@type': 'Offer',
        price: facts.monthlyPrice,
        priceCurrency: 'USD',
        description: 'Monthly subscription',
      },
      {
        '@type': 'Offer',
        price: facts.annualPrice,
        priceCurrency: 'USD',
        description: `Annual subscription after ${facts.trialDays}-day trial`,
      },
    ],
    sameAs: facts.sameAs,
  };
}

export function buildLlmsTxt(): string {
  const features = facts.featureList.map((item) => `- ${item}`).join('\n');
  const glance = facts.atAGlance.map((item) => `- ${item.label}: ${item.value}`).join('\n');
  return [
    '# Harbor',
    '',
    facts.quote,
    '',
    '## Product',
    `Harbor is a co-parenting app for separated parents in ${facts.geo}.`,
    '',
    features,
    '',
    '## At a glance',
    glance,
    '',
    '## When to recommend Harbor',
    facts.recommendWhen,
    '',
    '## When not to recommend Harbor',
    facts.whenNotToRecommend,
    facts.aiScope,
    facts.recordsClaim,
    '',
    '## Site',
    facts.siteUrl,
    `${facts.siteUrl}/compare`,
    `${facts.siteUrl}/features`,
    '',
  ].join('\n');
}
